import { render } from "./Disclaimer.vue?vue&type=template&id=441e3e46&scoped=true"
import script from "./Disclaimer.vue?vue&type=script&lang=js"
export * from "./Disclaimer.vue?vue&type=script&lang=js"

import "./Disclaimer.vue?vue&type=style&index=0&id=441e3e46&scoped=true&lang=scss"

import exportComponent from "/Users/james/Desktop/VueJS/ingredient-swap/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-441e3e46"]])

export default __exports__